/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiSubscriptionTier;
(function (ApiSubscriptionTier) {
    ApiSubscriptionTier["SUBSCRIPTION_TIER_START"] = "SubscriptionTierStart";
    ApiSubscriptionTier["SUBSCRIPTION_TIER_GROWTH"] = "SubscriptionTierGrowth";
    ApiSubscriptionTier["SUBSCRIPTION_TIER_PRO"] = "SubscriptionTierPro";
    ApiSubscriptionTier["SUBSCRIPTION_TIER_ENTERPRISE"] = "SubscriptionTierEnterprise";
})(ApiSubscriptionTier || (ApiSubscriptionTier = {}));
export function ApiSubscriptionTierFromJSON(json) {
    return ApiSubscriptionTierFromJSONTyped(json, false);
}
export function ApiSubscriptionTierFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiSubscriptionTierToJSON(value) {
    return value;
}
